import { render, staticRenderFns } from "./CartTooltip.vue?vue&type=template&id=cb52c1bc&scoped=true&"
import script from "./CartTooltip.vue?vue&type=script&lang=js&"
export * from "./CartTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CartTooltip.vue?vue&type=style&index=0&id=cb52c1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb52c1bc",
  null
  
)

export default component.exports